





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Messages, MessageModel } from '../models'

declare var YT: any

@Component({})
export default class LoginForm extends Vue {

  get activeMessage(): MessageModel {
    const res = Messages.slideshowMessages[this.activeIndex]
    if (!res && this.activeIndex > 0) {
      this.activeIndex = 0
    }
    return Messages.slideshowMessages[this.activeIndex]
  }

  get slideshowMessages(): MessageModel[] {
    return Messages.slideshowMessages
  }
  Messages = Messages

  activeIndex = 0
  carouselTiming = 10000
  // maxVideoPlaytime = 30000 // 30 seconds max video playtime - commented out, for now

  galleryTimeoutInterval: any = null
  showingImage = true
  waitForVideoRetryCount = 0
  existingPlayerRefs: any = {}
  prevExistingPlayerRefs: any = {}
  existingPlayerRefsCallbacks: any = {}

  @Watch('slideshowMessages')
  onPropertyChanged(messages: MessageModel[], oldMessages: MessageModel[]) {
    const newMessagesHash = messages.reduce((r, m) => {
      r += `${m.id}_`
      return r
    }, '')
    const oldMessagesHash = oldMessages.reduce((r, m) => {
      r += `${m.id}_`
      return r
    }, '')

    if (newMessagesHash !== oldMessagesHash) {
      this.destroyAllVideoPlayers()
    }
  }

  destroyAllVideoPlayers() {
    Object.keys(this.existingPlayerRefs).forEach((key) => {
      if (this.existingPlayerRefs[key]) {
        if (this.existingPlayerRefs[key].removeEventListener) {
          this.existingPlayerRefs[key].removeEventListener('onReady', this.existingPlayerRefsCallbacks[key])
        }
        this.existingPlayerRefs[key] = null
        this.existingPlayerRefsCallbacks[key] = null
        delete this.existingPlayerRefs[key] // delete from current video players refs
        delete this.existingPlayerRefsCallbacks[key]
      }
    })
  }

  cleanupDestroyedVideoPlayers() {
    let needToDestroyPlayers: boolean = false
    Object.keys(this.existingPlayerRefs).forEach((key) => {
      if (!Messages.slideshowMessages.find((item) => item.id === +key)) {
        needToDestroyPlayers = true
      }
    })
    if (needToDestroyPlayers) {
      this.destroyAllVideoPlayers()
    }
  }

  protected mounted() {
    this.initSlideShow()
  }

  protected onPlayerReady(event: any) {
    clearTimeout(this.galleryTimeoutInterval)
    const activeMessageId = Messages.slideshowMessages[this.activeIndex].id
    if (!this.existingPlayerRefs[activeMessageId] || !this.existingPlayerRefs[activeMessageId].mute) {
      if (!this.existingPlayerRefs[activeMessageId].mute) {
        this.destroyAllVideoPlayers()
      }
      this.incrementActiveSlideshowIndex()
      this.initSlideShow()
      return
    }
    this.existingPlayerRefs[activeMessageId].mute()
    this.existingPlayerRefs[activeMessageId].seekTo(0, true)
    this.existingPlayerRefs[activeMessageId].playVideo()
    let totalVideoSizeInSeconds = this.existingPlayerRefs[activeMessageId].getDuration() * 1000
    // fade in effect must not overlay with YT video reccomendations
    if (totalVideoSizeInSeconds > 5000) {
      totalVideoSizeInSeconds -= 500
    }

    this.galleryTimeoutInterval = setTimeout(() => {
      this.incrementActiveSlideshowIndex()
      this.initSlideShow()
    }, totalVideoSizeInSeconds)
    // }, Math.min(this.maxVideoPlaytime, totalVideoSizeInSeconds)) -- commented out for now
  }

  protected beforeDestroy() {
    this.destroyAllVideoPlayers()
    clearInterval(this.galleryTimeoutInterval)
  }
  private initSlideShow() {
    clearInterval(this.galleryTimeoutInterval)
    this.cleanupDestroyedVideoPlayers()
    if (this.activeMessage && this.activeMessage.mediaType !== 'image') {
      this.setupVideoPlayback()
    } else {
      this.galleryTimeoutInterval = setInterval(() => {
        this.incrementActiveSlideshowIndex()
        this.initSlideShow()
      }, this.carouselTiming)
    }
  }

  private setupVideoPlayback() {
    if ((window as any).youtubePlayerWasLoaded) {
      const activeMessageId = Messages.slideshowMessages[this.activeIndex].id
      if (!this.existingPlayerRefs[activeMessageId]) {
        const onReady = this.existingPlayerRefsCallbacks[activeMessageId] = this.onPlayerReady.bind(this)
        const player = new YT.Player(`mediaplayer-${activeMessageId}`, {
          events: {
            onReady,
          },
          playerVars: { autoplay: 1, controls: 0, disablekb: 1, modestbranding: 1 },
        })

        this.existingPlayerRefs[activeMessageId] = player
        this.galleryTimeoutInterval = setTimeout(() => {
          this.incrementActiveSlideshowIndex()
          this.initSlideShow()
        }, 3000)
      } else {
        this.onPlayerReady(null)
      }
    } else {
      this.galleryTimeoutInterval = setTimeout(() => {
        if (this.waitForVideoRetryCount > 3) {
          this.waitForVideoRetryCount = 0
          this.incrementActiveSlideshowIndex()
          this.initSlideShow()
        } else {
          this.setupVideoPlayback()
          this.waitForVideoRetryCount++
        }
      }, 500)
    }
  }

  private incrementActiveSlideshowIndex() {
    this.activeIndex++
    if (this.activeIndex >= Messages.slideshowMessages.length) {
      this.activeIndex = 0
    }
  }
}
